import partition from "lodash/partition";
import { put, select, takeEvery } from "redux-saga/effects";
import { SET_SETTING } from "constants/actionTypes";
import { Settings } from "constants/settings";
import { setSetting } from "actions";
import { FilterState } from "reducers/settings/types";
import { getSetting } from "selectors";
import { FilterType } from "constants/filters";
import { PenRangeFilter } from "components/Filter/Form/PenRange/processData";

interface SetSetingAction {
  type: string;
  payload?: Record<string, any>;
}

function getIsActionForSetting(action: SetSetingAction, setting: string) {
  return setting in action.payload;
}

function* clearPenRangeFilter(roundId: number) {
  // Clears all the active pen-range type filters

  const state = yield select();

  const filterState: FilterState = getSetting(Settings.filter)(state);

  const [invalidPenRangeFilters, otherFilters] = partition(
    filterState.filterSettings,
    (filterSetting: PenRangeFilter) =>
      filterSetting.type === FilterType.PenRange &&
      filterSetting.roundId !== roundId,
  );

  if (!invalidPenRangeFilters.length) {
    return;
  }

  const newFilterState: FilterState = {
    ...filterState,
    filterSettings: otherFilters,
  };

  yield put(setSetting(Settings.filter, newFilterState));
}

function* penRangeFilter(newFilterState: FilterState) {
  // Clears the pen-range filters from the FilterState when the round filter is set to a different round
  const { filterSettings } = newFilterState || { filterSettings: [] };
  const penRangeFilters: PenRangeFilter[] = filterSettings.filter(
    (filterSetting: PenRangeFilter) =>
      filterSetting.type === FilterType.PenRange,
  ) as PenRangeFilter[];

  if (penRangeFilters.length === 0) {
    return;
  }

  // Update the global Round Filter to match the pen-range filter when it isn't already set
  const { roundId } = penRangeFilters[0];
  const state = yield select();
  const currentRoundId = getSetting(Settings.round)(state);
  if (roundId === currentRoundId) {
    return;
  }

  yield put(setSetting(Settings.round, roundId));
}

function* onSetSetting(action: SetSetingAction) {
  const { payload } = action;
  if (!payload) {
    return;
  }

  if (getIsActionForSetting(action, Settings.round)) {
    const roundId: number = payload[Settings.round];
    yield clearPenRangeFilter(roundId);
  } else if (getIsActionForSetting(action, Settings.filter)) {
    const filterState: FilterState = payload[Settings.filter];
    yield penRangeFilter(filterState);
  }
}

export default function* sagas() {
  yield takeEvery(SET_SETTING, onSetSetting);
}
